/* eslint-disable no-nested-ternary */
import { useSelector, useDispatch } from 'react-redux'
import { authSelectors } from '@ucheba/store/auth'
import { useRouter } from 'next/router'
import {
  redirect,
  removeQueryParameters,
  stringifyUrl,
} from '@ucheba/utils/helpers/router'
import { coreQuery } from '@ucheba/utils/constants/queries'
import { profileSelectors, profileThunks } from '@ucheba/store/profile'
import { institutionItemSelectors } from '@ucheba/store/institutions/item'
import {
  chancesOfAdmissionSelector,
  chancesOfAdmissionThunk,
} from '@ucheba/store/institutions/chancesOfAdmission'
import { EInstitutionType } from '@ucheba/store/institutions/item/types'
import { ELoading } from '@ucheba/store/utils/response/types'
import { getParsedCookies } from '@ucheba/utils/helpers/core'
import { authCookieToken } from '@ucheba/utils/constants/core'

export const useButtonAssessmentOfChances: any = (
  openResultList: () => void,
  restartAssessmentOfChances?: () => void
) => {
  const dispatch = useDispatch()
  const isAuth = useSelector(authSelectors.isAuth)

  const { id: referId, type } =
    useSelector(institutionItemSelectors.currentInstitution) || {}

  const isRender = EInstitutionType.University === type.value

  const chancesOfAdmission =
    useSelector(chancesOfAdmissionSelector.chancesOfAdmission) || {}

  const chancesOfAdmissionLoading = useSelector(chancesOfAdmissionSelector.loading)

  const loading = useSelector(institutionItemSelectors.loading)

  const router = useRouter()

  const { asPath: currentUrl, query } = router

  const handleOpenRatesClick = (): void => {
    redirect({
      location: stringifyUrl('/auth', {
        update: {
          [coreQuery.redirect]: stringifyUrl(removeQueryParameters(currentUrl), {
            update: {
              ...query,
              showOddsStep1: 1,
            },
          }),
        },
      }),
    })
  }

  const handleGetResultList = async (): Promise<void> => {
    const parsedCookie = getParsedCookies()
    const tokenString = parsedCookie[authCookieToken]

    if (!tokenString || !isAuth) {
      handleOpenRatesClick()

      return undefined
    }

    if (!chancesOfAdmission?.currentProbability) {
      try {
        const res = await dispatch<any>(profileThunks.get({}))

        const profile = res?.payload
        if (profile) {
          const scores = profile?.enrolleeInfo?.exams?.length
            ? profile?.enrolleeInfo?.exams.map(({ exam, score }) => ({
                examId: exam.id,
                score,
              }))
            : []

          openResultList()

          await dispatch<any>(
            chancesOfAdmissionThunk.fetchChancesAdmission({
              data: {
                type: 'institution',
                referId,
                scores,
                achievementIds: profile?.enrolleeInfo?.achievements,
                readyToExam: profile?.enrolleeInfo?.readyForAdditionalExam,
              },
            })
          )
        }
      } catch (e) {
        console.log(e)
      }
      return undefined
    }

    openResultList()

    return undefined
  }

  const { countPrograms, currentProbability } =
    useSelector(institutionItemSelectors.shortChancesOfAdmission) || {}

  const probability =
    currentProbability !== null &&
    (currentProbability > 90 ? 'high' : currentProbability > 50 ? 'medium' : 'low')

  const handleAssessmentOfChances = (): void => {
    const parsedCookie = getParsedCookies()
    const tokenString = parsedCookie[authCookieToken]

    if (tokenString && isAuth && restartAssessmentOfChances) {
      restartAssessmentOfChances()

      return
    }

    handleOpenRatesClick()
  }

  return {
    isAuth,
    isRender,
    chancesOfAdmissionLoading:
      chancesOfAdmissionLoading === ELoading.pending || loading === ELoading.pending,
    probability,
    countPrograms,
    currentProbability,
    handleGetResultList,
    handleAssessmentOfChances,
  }
}
